document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("form");
  const contactText = document.getElementById("contactText");
  const requiredInputs = form.querySelectorAll("[required]");
  const errorBlock = document.getElementById("errorBlock"); // IDでエラーブロックを参照
  const submitButton = document.getElementById("sendBtn"); // 送信ボタンの選択

  function validateForm() {
    let isFormValid = true;
    errorBlock.classList.add("hidden"); // 最初にエラーブロックを隠す
    submitButton.style.pointerEvents = "none"; // 初期状態で送信ボタンを非活性化

    // 必須入力フィールドの確認
    requiredInputs.forEach(input => {
      if (!input.value.trim()) {
        isFormValid = false;
        errorBlock.classList.remove("hidden"); // エラーが見つかった場合、エラーブロックを表示
      }
    });

    // textareaが日本語を含んでいるか確認
    if (!/[^\x00-\x7F]+/.test(contactText.value)) {
      isFormValid = false;
      errorBlock.classList.remove("hidden"); // エラーブロックを表示
    }

    if (isFormValid) {
      submitButton.style.pointerEvents = "auto"; // バリデーションがクリアされたら送信ボタンを活性化
    }

    return isFormValid;
  }

  // リアルタイムでのバリデーション
  form.addEventListener("input", function () {
    validateForm(); // ユーザーが入力するたびにバリデーションを実行
  });

  // クエリパラメーターで指定されたラジオボタンを選択状態にする
  const params = new URLSearchParams(window.location.search);
  const select = params.get("select");
  if (select) {
    const radioButton = document.getElementById(select);
    if (radioButton) {
      radioButton.checked = true;
    }
  }
});
